import { Grid, Typography } from "@mui/material";
import React, { ChangeEvent } from "react";
import { useNavigate } from "react-router";
import Tableau from "../../../../components/tableau/Tableau";
import { DossierLocationItem, Profil } from "../../../../services/Api/swagger";
import { getInfoTableau } from "../helpers";
import { dossiersLocationHeader } from "./tableauHeader";
import { Warning } from "@mui/icons-material";

interface Props {
  classes?: any; // Surcharge de style CSS injecté par withStyles
  page: number;
  nbrElementParPage: number;
  sortColumn: string;
  sortOrder: "asc" | "desc";
  searchCount: number;
  alerteEnCoursSuppression: boolean;
  dossiersLocation: DossierLocationItem[];
  genererLoading?: boolean;

  // searchParams?: any;
  onChangeNbrElementParPage(nbrElementParPage: number): void;

  onChangePage(page: number): void;

  onChangeTri(sortColumn: string, sortOrder: string): void;

  onlyBesse?: boolean;
  isAccepterRefuserLocationLoading?: boolean;

  setSelectedDossier(ref: string): void;

  onSetDuplicationDossier(ref: string): void;

  onSetAccepterDossier(ref: string): void;

  onSetRefuserDossier(ref: string): void;

  onSetAccepterRefuserDossier(dossierLocationItem: any): void;

  canAcceptRefuseLocation?: boolean;
  infoProfil?: Profil;

  onDelete(ref: string): void;

  onGenerer(ref: string): void;
  displayCandidatLocataire?: boolean;
}

interface State {
  message: string; // Message  (Erreur / Information)
}

const ResultatsRecherche = ({
  sortOrder,
  onChangePage,
  onChangeNbrElementParPage,
  setSelectedDossier,
  onChangeTri,
  searchCount,
  sortColumn,
  onDelete,
  onGenerer,
  canAcceptRefuseLocation,
  onSetAccepterDossier,
  onSetAccepterRefuserDossier,
  onSetDuplicationDossier,
  onSetRefuserDossier,
  onlyBesse,
  page,
  nbrElementParPage,
  alerteEnCoursSuppression,
  isAccepterRefuserLocationLoading,
  infoProfil,
  genererLoading,
  dossiersLocation,
  displayCandidatLocataire,
}: Props) => {
  const handleTrier = (
    event: React.MouseEvent<Element, MouseEvent> | null,
    colonneId: string
  ) => {
    event && event.preventDefault();
    let order = "asc";
    if (sortOrder === "asc") {
      order = "desc";
    }
    onChangeTri(colonneId, order);
  };
  const handleChangerPage = (
    event: React.MouseEvent<Element, MouseEvent> | null,
    page: number
  ) => {
    // event && event.preventDefault();
    onChangePage(page);
  };

  const handlechangerNbrResultatParPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    nbrElement: number
  ) => {
    event && event.preventDefault();
    onChangeNbrElementParPage(nbrElement);
  };

  const navigate = useNavigate();
  const onConsulter = (ref: string) => {
    setSelectedDossier(ref);
    navigate("/dossier-location/synthese");
  };

  const donneesTableau = getInfoTableau(
    dossiersLocation,
    displayCandidatLocataire
  );
  return (
    <React.Fragment>
      <Grid container>
        <Tableau
          isPaginer={true}
          page={page}
          type="dossiersLocation"
          headerDonnees={dossiersLocationHeader(displayCandidatLocataire)}
          trierPar={sortColumn}
          ordreDeTrie={sortOrder}
          donneesTableau={donneesTableau}
          nbrElementTotal={searchCount}
          alerteEnCoursSuppression={alerteEnCoursSuppression}
          nbrElementParPage={nbrElementParPage}
          onChangerPage={handleChangerPage}
          onChangerNbrResultatParPage={handlechangerNbrResultatParPage}
          onConsulter={onConsulter}
          onDelete={onDelete}
          onGenerer={onGenerer}
          onTrier={handleTrier}
          onSetDuplicationDossier={onSetDuplicationDossier}
          onSetAccepterDossier={onSetAccepterDossier}
          onSetRefuserDossier={onSetRefuserDossier}
          onSetAccepterRefuserDossier={onSetAccepterRefuserDossier}
          isAccepterRefuserLocationLoading={isAccepterRefuserLocationLoading}
          genererLoading={genererLoading}
          canAcceptRefuseLocation={canAcceptRefuseLocation}
          infoProfil={infoProfil}
        />
      </Grid>
      <div className="legend">
        <Grid container alignItems="self-end">
          *<Warning color="warning" />
          <Typography variant="caption">
            Ces dossiers de location seront supprimés dans moins de 30 jours
          </Typography>
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default ResultatsRecherche;
